module.exports = __webpack_public_path__ + "static/media/bringToFront.21c6cb9a.svg";